import { createContext, useContext, useState } from 'react';
import { useTenant } from '../../contexts/TenantContext';
import useGetStaffMe from './api/useGetStaffMe';

const StaffContext = createContext();
export const useStaff = () => useContext(StaffContext);

/**
 * The signed-in member of staff, and whose calendar the dashboard shows (docs/MULTI_PROVIDER.md,
 * flows 3 and 4). It lives in the admin frame, so the calendar and the block page share the choice.
 *
 * The calendar opens on the user's own provider; an admin who is none opens on the tenant's first.
 * Only an admin of a tenant with several providers can choose another one. Every dashboard call
 * names the shown provider, also on a tenant with one.
 */
export const StaffProvider = ({ children }) => {
  const { providers, hasSeveralProviders } = useTenant();
  const { data: staff, isPending, error } = useGetStaffMe();
  // Set only by the admin's choice; until then the default below holds.
  const [chosenProviderId, setChosenProviderId] = useState(null);

  const isAdmin = staff?.isAdmin ?? false;
  const canChooseProvider = isAdmin && hasSeveralProviders;
  const shownProviderId = (canChooseProvider && chosenProviderId)
    || staff?.providerId
    || providers[0]?.id;

  return (
    <StaffContext.Provider
      value={{
        loading: isPending,
        error,
        isAdmin,
        // The user's own provider; absent for an admin who is none.
        ownProviderId: staff?.providerId,
        canChooseProvider,
        shownProviderId,
        showProvider: setChosenProviderId,
      }}
    >
      {children}
    </StaffContext.Provider>
  );
};

export default StaffContext;
